import { ENVS } from '@adsk/acs-sc-web-platform-api';

export const RFI_PATHS = {
  [ENVS.QA]: '/construction/rfis-qa/v3',
  [ENVS.STAGING]: '/construction/rfis-stg/v3',
  [ENVS.PRODUCTION]: '/construction/rfis/v3',
};

export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Delete = 'DELETE',
  Patch = 'PATCH',
  Put = 'PUT',
}

export const headers = {
  'Content-Type': 'application/json',
};
